import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_9: FaireProductEntity = {
  token: "atc_toast_9",
  type: "product",
  name: "Valley of Gold Incense Sticks",
  brandName: "Primer",
  imageUrl: "",
  priceDollars: 12.0,
  msrpDollars: 24.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
